import { EntityType } from '@frontend/common';
import { ReactiveObjectList } from '@frontend/components/list-v2';
import { CommonMessage } from '@frontend/lang';
import { ModalType } from '@frontend/modal';
import { ProductExtendedClient } from '@frontend/product/api';
import { ProductExtended, ProductType } from '@frontend/product/types';

import { usePlatformModalHost } from '../../../modal/platform-modal-host/platform-modal-host.context';
import { ApplicationContainer } from '../../application-container/application-container';
import OverviewHeader from '../../header/overview-header';
import { CreateKitModal } from './create-kit-modal/create-kit-modal.component';
import { useKits } from './kits.controller';

export const Kits = () => {
    const viewProps = useKits();
    const { openPlatformDetail } = usePlatformModalHost();

    return (
        <ApplicationContainer>
            <OverviewHeader
                title={
                    <div className='flex gap-2'>
                        <span>{CommonMessage.OBJECTS.CATALOG.DEFAULT}</span>
                        <span>/</span>
                        <span>{CommonMessage.OBJECTS.PRODUCT_KIT.PLURAL}</span>
                    </div>
                }
                create={{
                    onCreate: () =>
                        viewProps.openModal(viewProps.createKitModalId, () => <CreateKitModal />, {}, { type: ModalType.PANE, className: 'max-w-[600px]' }),
                    entity: EntityType.PRODUCT,
                    overwriteCreateLabel: (
                        <div className='flex gap-1'>
                            <span>{CommonMessage.BUTTONS.CREATE}</span>
                            <span className='lowercase'>{CommonMessage.OBJECTS.PRODUCT_KIT.DEFAULT}</span>
                        </div>
                    )
                }}
            />
            <ReactiveObjectList<ProductExtended>
                fetch={(arg) =>
                    ProductExtendedClient.fetchExtendedProducts({
                        ...arg,
                        account_id: viewProps.currentAccount,
                        type: ProductType.KIT
                    })
                }
                dispatch={viewProps.dispatch}
                onSelectElement={(obj) => openPlatformDetail({ entityType: EntityType.PRODUCT, id: obj.id })}
                columns={{
                    columns: ['name', 'sku', 'ean'],
                    headerOverwrite: new Map([
                        ['name', CommonMessage.OBJECTS.PRODUCT_KIT.DEFAULT],
                        ['sku', CommonMessage.OBJECTS.PRODUCT.SKU],
                        ['ean', CommonMessage.OBJECTS.PRODUCT.EAN]
                    ])
                }}
                type={EntityType.PRODUCT}
                eventListener={EntityType.PRODUCT}
                activeFilter={{
                    searchKeys: ['name', 'sku', 'ean'],
                    displayName: new Map([
                        ['name', CommonMessage.OBJECTS.PRODUCT_KIT.DEFAULT],
                        ['sku', CommonMessage.OBJECTS.PRODUCT.SKU],
                        ['ean', CommonMessage.OBJECTS.PRODUCT.EAN]
                    ])
                }}
            />
        </ApplicationContainer>
    );
};
